import iconMap from 'bootstrap-icons/font/bootstrap-icons.json';

// Full list of every Bootstrap Icons name bundled with the app (~2078 icons),
// sorted alphabetically for a predictable browse order in the icon picker.
export const ALL_BOOTSTRAP_ICON_NAMES = Object.keys(iconMap).sort();
